/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IOfferHistoryStatusCountItem1 {
  /** Статус объявления **/
  status: EStatus;
  /** Количество предложений для заданного статуса **/
  offersCount: number;
}

export enum EStatus {
  /** Опубликовано **/
  'Published' = 'published',
  /** Снято с публикации **/
  'Deactivated' = 'deactivated',
}
